import { BaseModel } from "model/BaseModel";

export default class HelpdeskTipoChamado implements BaseModel {

    id: number;
    codigo: string | null;
    descricao: string;
    compra: boolean;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        descricao = '',
        compra = true
    ) {
        this.id = id;
        this.codigo = codigo;
        this.descricao = descricao;
        this.compra = compra;
    }
}